import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { LoanPurposeValue } from '@portal-workspace/grow-shared-library';
import { CellComponent } from '../application-summary-component/cell.component';
import { EllipsisPipe } from '../../pipes/ellipsis.pipe';
import { LooseCurrencyPipe } from '../../pipes/loose-currency.pipe';

@Component({
  selector: 'loan-purpose-summary',
  templateUrl: './loan-purpose-summary.component.html',
  styleUrls: ['./loan-purpose-summary.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDividerModule,
    CellComponent,
    EllipsisPipe,
    LooseCurrencyPipe
  ]
})
export class LoanPurposeSummaryComponent {
  @Input() loanPurpose: LoanPurposeValue | null = null;
  @Input({required: false}) needPadding = true;
  @Input({required: false}) termRenewal: boolean | null = null;
  /**
   * Checks if the loan purpose has any additional fields beyond the basic name
   */
  get hasAdditionalFields(): boolean {
    if (!this.loanPurpose) return false;
    
    return !!(
      this.loanPurpose.isIncomeGeneratingAsset !== undefined ||
      this.loanPurpose.expectedMonthlyIncome !== undefined ||
      this.loanPurpose.hasExistingFinanceCommitments !== undefined ||
      this.loanPurpose.lender !== undefined ||
      this.loanPurpose.loanValue !== undefined ||
      this.loanPurpose.taxBalance !== undefined ||
      this.loanPurpose.purchasePrice !== undefined ||
      this.loanPurpose.purposeDescription !== undefined ||
      this.termRenewal !== null
    );
  }

  /**
   * Converts boolean values to Yes/No strings
   */
  booleanToYesNo(value: boolean | undefined): string {
    if (value === undefined || value === null) return '';
    return value ? 'Yes' : 'No';
  }
} 